import createLucideIcon from '../createLucideIcon';

const ArrowDownLeftFromCircle = createLucideIcon('ArrowDownLeftFromCircle', [
  ['polyline', { points: '8,22 2,22 2,16 ', key: '1kl55u' }],
  ['line', { x1: '2', y1: '22', x2: '12', y2: '12', key: '1ikfkt' }],
  [
    'path',
    { d: 'M2,12C2,6.5,6.5,2,12,2s10,4.5,10,10s-4.5,10-10,10', key: '1wixhx' },
  ],
]);

export default ArrowDownLeftFromCircle;
